import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getProperty } from '../propertyEndpoints'
import type { Property } from '../../types/propertyTypes'

interface PropertyQueryOptions {
  /**
   * Poll interval in ms, or false to not poll (default). Given the cached
   * property so callers never read the hook's own `data` ref here: TanStack
   * calls this while the query is being created, before that ref is assigned.
   */
  refetchInterval?: (property: Property | undefined) => number | false
}

export function usePropertyQuery(
  id: MaybeRefOrGetter<string>,
  options: PropertyQueryOptions = {},
) {
  return useQuery({
    queryKey: () => propertyKeys.detail(toValue(id)),
    queryFn: () => getProperty(toValue(id)),
    enabled: () => Boolean(toValue(id)),
    refetchInterval: (query) => options.refetchInterval?.(query.state.data) ?? false,
  })
}
